const endpoints = {
	saveProjectPlanning: '/project_planning/saveProjectPlanning',
	getProjectPlanning: '/project_planning/getProjectPlanning',
	getGeneralProjectPlanning: '/project_planning/getGeneralProjectPlanning',
	setGeneralProjectPlanning: '/project_planning/setGeneralProjectPlanning'
}
export {endpoints}